import { Box, Grid, Typography } from "@mui/material";
import COLORS from "../../styles/colors";
import StoryCard from "./StoryCard";

export type Story = {
  id: string;
  title: string;
  description: string;
  image: string;
  path: string;
};

type SuccessStoriesProps = {
  stories: Story[];
};

export const messages = {
  saasSuccessStudies: "SaaS Success Studies",
};

const SuccessStories: React.FC<SuccessStoriesProps> = ({ stories }) => {
  return (
    <Box px="8%" pb={10} bgcolor={COLORS.LIGHT_BLUE}>
      <Typography
        fontSize="30px"
        fontWeight="700"
        color={COLORS.DARK_BLUE}
        textAlign="center"
        py={6}
      >
        {messages.saasSuccessStudies}
      </Typography>
      <Grid container spacing={16}>
        {stories.map((story, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={index}>
            <StoryCard {...story} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SuccessStories;